import React from "react";
import MobileBottomSheet from "./MobileBottomSheet";
import MobileSelect from "./MobileSelectDropdown";

export default function MobileFilterSheet({
  isOpen,
  onClose,
  title = "정렬 및 필터",
  sortLabel = "정렬 기준",
  sortValue,
  sortOptions = [],
  onChangeSort,
  orderLabel = "정렬 방향",
  sortOrder = "asc",
  onChangeSortOrder,
  // New Filters
  faithFilter = "all",
  onChangeFaithFilter,
  attendanceFilter = "all",
  onChangeAttendanceFilter,
  genderFilter = "all",
  onChangeGenderFilter,
  themeColor = "#354F38",
}) {
  const filterSectionClass = "space-y-3 pt-6 border-t border-gray-100";
  const filterTitleClass = "text-sm font-black text-gray-800 flex items-center gap-1.5";
  const flexWrapClass = "flex flex-wrap gap-2";
  const buttonBaseClass = "h-10 px-4 rounded-full text-[13px] font-bold transition-all active:scale-[0.96] flex items-center justify-center outline-none shrink-0 border";

  const getButtonProps = (isActive) => {
    if (isActive) {
      return {
        className: `${buttonBaseClass} text-white shadow-sm border-transparent`,
        style: { backgroundColor: themeColor, borderColor: themeColor }
      };
    }
    return {
      className: `${buttonBaseClass} bg-white border-gray-200 text-gray-500 hover:bg-gray-50`,
      style: {}
    };
  };
  const footerContent = (
    <div className="flex gap-2.5 pt-1 pb-4">
      <button
        onClick={() => {
          onChangeFaithFilter("all");
          onChangeAttendanceFilter("all");
          onChangeGenderFilter("all");
          onChangeSortOrder("asc");
        }}
        className="flex-[1] h-[52px] rounded-[20px] border border-gray-200 text-gray-500 font-bold text-[15px] bg-white active:scale-[#0.98] transition-all shadow-sm flex items-center justify-center"
      >
        초기화
      </button>
      <button
        onClick={onClose}
        className="flex-[2] h-[52px] rounded-[20px] text-white font-bold text-[15px] shadow-lg active:scale-[#0.98] transition-all flex items-center justify-center border-none"
        style={{ backgroundColor: themeColor, boxShadow: `0 10px 15px -3px ${themeColor}40` }}
      >
        적용하기
      </button>
    </div>
  );

  return (
    <MobileBottomSheet
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      height="85%"
      footer={footerContent}
    >
      <div className="space-y-7 pb-8 pt-2">
        {/* Sort Section */}
        <div className="space-y-5">
          <div className="space-y-3">
            <h4 className={filterTitleClass}>{sortLabel}</h4>
            <MobileSelect value={sortValue} options={sortOptions} onChange={onChangeSort} />
          </div>

          <div className="space-y-3">
            <h4 className={filterTitleClass}>{orderLabel}</h4>
            <div className={flexWrapClass}>
              <button
                type="button"
                onClick={() => onChangeSortOrder("asc")}
                {...getButtonProps(sortOrder === "asc")}
                className={`${getButtonProps(sortOrder === "asc").className} flex-1 min-w-[100px]`}
              >
                오름차순 (↑)
              </button>
              <button
                type="button"
                onClick={() => onChangeSortOrder("desc")}
                {...getButtonProps(sortOrder === "desc")}
                className={`${getButtonProps(sortOrder === "desc").className} flex-1 min-w-[100px]`}
              >
                내림차순 (↓)
              </button>
            </div>
          </div>
        </div>

        {/* Faith State Filter */}
        <div className={filterSectionClass}>
          <h4 className={filterTitleClass}>신앙상태 필터</h4>
          <div className={flexWrapClass}>
            {["all", "초신자", "장기결석"].map((opt) => (
              <button
                key={opt}
                type="button"
                onClick={() => onChangeFaithFilter(opt)}
                {...getButtonProps(faithFilter === opt)}
              >
                {opt === "all" ? "전체보기" : opt}
              </button>
            ))}
          </div>
        </div>

        {/* Attendance Filter */}
        <div className={filterSectionClass}>
          <h4 className={filterTitleClass}>출석현황 필터</h4>
          <div className={flexWrapClass}>
            {[
              { id: "all", label: "전체보기" },
              { id: "2weeks", label: "2주+ 미출석" },
              { id: "4weeks", label: "한달+ 미출석" },
            ].map((opt) => (
              <button
                key={opt.id}
                type="button"
                onClick={() => onChangeAttendanceFilter(opt.id)}
                {...getButtonProps(attendanceFilter === opt.id)}
              >
                {opt.label}
              </button>
            ))}
          </div>
        </div>

        {/* Gender Filter */}
        <div className={filterSectionClass}>
          <h4 className={filterTitleClass}>성별 필터</h4>
          <div className={flexWrapClass}>
            {["all", "남", "여"].map((opt) => (
              <button
                key={opt}
                type="button"
                onClick={() => onChangeGenderFilter(opt)}
                {...getButtonProps(genderFilter === opt)}
              >
                {opt === "all" ? "전체보기" : opt}
              </button>
            ))}
          </div>
        </div>
      </div>
    </MobileBottomSheet>
  );
}

